import {subscribeExt} from "../modules/subscribe";
import {ticketsExt} from "../modules/tickets";

export function eventDetailPage() {

    function doAnimations(){

        if(window.pageYOffset > 350){
            $('.tribe-events-detail').addClass('event-scroll');
        } else {
            $('.tribe-events-detail').removeClass('event-scroll');
        }

        if(($(window).scrollTop() + $(window).height()) > ($(document).height() - 1500)){
            $('.tribe-events-detail').removeClass('hide-foot');
        } else {
            $('.tribe-events-detail').addClass('hide-foot');
        }
    }

    function showViewport() {
        var selector    = document.querySelector('.events-container-content');
        var height      = Math.max(selector.clientHeight, window.innerHeight || 0);
        $('.side-overlay').css({'height': height+'px'});

        var $window = $(window);
        var $sidebar = $("#events-detail-sidebar");
        var $sidebarHeight = $sidebar.innerHeight();
        var $sibling_block_height = $('.event-content');
        var $margin_top = 110;

        if($sidebarHeight < $sibling_block_height.innerHeight() - 200) {

            var $footerOffsetTop = $(".table-calendar").offset().top - 150;
            var $sidebarOffset = $sidebar.offset();

            $window.scroll(function () {
                if ($window.scrollTop() > $sidebarOffset.top - $margin_top) {
                    $sidebar.addClass("fixed");
                    $sidebar.css({"margin-top": $margin_top});
                } else {
                    $sidebar.css({"margin-top": 0});
                    $sidebar.removeClass("fixed");
                }
                if ($window.scrollTop() + $sidebarHeight > $footerOffsetTop - $margin_top) {
                    $sidebar.css({"margin-top": '-10px'});
                    $sidebar.css({"top": -($window.scrollTop() + $sidebarHeight - $footerOffsetTop)});
                } else {
                    $sidebar.css({"top": "0",});
                }
            });
        }
    }

    function actions() {

        if($('body').hasClass('events-single')){
            subscribeExt(500);
            ticketsExt('.tribe-tickets-form-row input.qty');
        }

        $('.tribe-events-detail').addClass('hide-foot');

        if ($('.events-container-content').length > 0) {
            $('.prettySocial').prettySocial();
            window.onload = showViewport;
            window.onresize = showViewport;

            $(window).on('scroll', doAnimations);
        }
    }

    actions();

}


// WEBPACK FOOTER //
// ./assets/js/pages/event_detail.js